import { fromJS } from 'immutable';
import * as constants from './constants';


const initialState = {
  processingToken: true,
  gettingAssets: true,
};

export default function assetsConsolidation(state = initialState, { type, payload }) {
  // if (type.indexOf('[asset-consolidation]') > -1)  console.log(type, payload);
  switch (type) {
    case constants.UPDATE_PROPS:
      return {
        ...state,
        ...payload,
      };
    case `${constants.PROCESS_HASHTOKEN}_SUCCESS`:
      return {
        ...state,
        processingToken: false,
        ...payload.assetsLanding,
      };
    case `${constants.GET_ASSETS}_SUCCESS`:
      return {
        ...state,
        gettingAssets: false,
        ...payload,
      }
    case `${constants.CONSOLIDATE_ASSETS}_SUCCESS`:
      return {
        ...state,
        consolidationSuccess: true,
      }
    case `${constants.CONSOLIDATE_ASSETS}_ERROR`:
      return {
        ...state,
        consolidationSuccess: false,
        errorText: 'Oops, something went wrong, please contact us!',
      }
    case constants.CLEAR_STORE:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/assets-consolidation/__storeFiles__/reducer.js